import { type FC, useContext } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'

export const LoginRegistrationRegistrationFormLastNameInput: FC = () => {
  const intl = useIntl()
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState

  return (
    <FormControl
      error={!model.validator.isPropertyValid('lastName')}
      required
      value={model.lastName}
    >
      <FormLabel htmlFor="registerForm-lastName">
        {intl.formatMessage({ id: 'general.label.surname' })}
      </FormLabel>
      <Input
        {...registrationFormState.makeInputProps('lastName', {
          validateOnBlur: true,
        })}
        id="registerForm-lastName"
        slotProps={{
          input: { 'data-qa-id': 'register-form-lastName' },
        }}
      />
      {model.validator.getFirstErrorFor('lastName') && (
        <FormHelperText>
          {model.validator.getFirstErrorFor('lastName')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
